import * as S from './constants';

export default Object.freeze({
  [S.MAIN_CARD_STATIC_TITLE]: 'Teicama kvalitāte par samērīgām cenām!',
  [S.MAIN_CARD_STATIC_FIRST]: '8. Closed'
})


// WEBPACK FOOTER //
// ./src/translations/strings.LV.js